import { render, staticRenderFns } from "./Col.vue?vue&type=template&id=5e3bce04&scoped=true&"
import script from "./Col.vue?vue&type=script&lang=js&"
export * from "./Col.vue?vue&type=script&lang=js&"
import style0 from "./Col.vue?vue&type=style&index=0&id=5e3bce04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3bce04",
  null
  
)

export default component.exports